import React from 'react';
import { IconProps } from '@/models/IconProps';

const Backward10Icon: React.FC<IconProps> = ({ height = '25', width = '25', strokeColor = '#1F2126' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={'0 0 ' + width + ' ' + height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.755 0C9.70113 0 6.91449 1.15537 4.79404 3.03906L2.75498 1V7H8.75498L6.21006 4.45508C7.9645 2.93102 10.243 2 12.755 2C18.2895 2 22.755 6.46547 22.755 12C22.755 17.5345 18.2895 22 12.755 22C7.22045 22 2.75498 17.5345 2.75498 12C2.75686 11.8675 2.73238 11.7359 2.68296 11.613C2.63355 11.49 2.56019 11.3781 2.46714 11.2837C2.3741 11.1893 2.26323 11.1144 2.14097 11.0632C2.01871 11.0121 1.88751 10.9858 1.75498 10.9858C1.62246 10.9858 1.49125 11.0121 1.369 11.0632C1.24674 11.1144 1.13587 11.1893 1.04282 11.2837C0.949778 11.3781 0.876418 11.49 0.827004 11.613C0.77759 11.7359 0.753109 11.8675 0.754983 12C0.754983 18.6155 6.13952 24 12.755 24C19.3704 24 24.755 18.6155 24.755 12C24.755 5.38453 19.3704 0 12.755 0ZM15.4425 8.34961C13.6265 8.34961 12.4835 9.71092 12.4835 12.0449C12.4835 14.3789 13.6105 15.7744 15.4425 15.7754C17.2685 15.7754 18.4015 14.3748 18.4015 12.0508C18.4015 9.70678 17.2545 8.34961 15.4425 8.34961ZM8.88975 8.53906L7.09873 9.75977V11.3027L8.79795 10.1543H8.88975V15.5859H10.6827V8.53906H8.88975ZM15.4425 9.72656C16.1265 9.72656 16.5851 10.4969 16.5851 12.0449C16.5851 13.6029 16.1265 14.3984 15.4425 14.3984C14.7585 14.3984 14.3038 13.6029 14.3038 12.0449C14.3038 10.4969 14.7585 9.72656 15.4425 9.72656Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default Backward10Icon;
